import Player from "components/UploadPage/LeftSidebar/Player";
import Layers from "components/UploadPage/LeftSidebar/Layers";
import Drafts from "components/UploadPage/LeftSidebar/Drafts";
import StartMenu from "components/UploadPage/LeftSidebar/StartMenu";
import Loading from "components/shared/Loading";
import Box from "@mui/material/Box";
import useUploadContext from 'hooks/useUploadContext';
import "./index.scss";

const LeftSidebar = () => {
    const { leftTab, loading } = useUploadContext();
    return (
        <Box className="left-sidebar-wrapper">
            <Box className="layers-drafts-wrapper">
                { loading && <Box className="loading"><Loading height={100} width={100} /></Box> }
                {    ['drafts', 'draftDeleteConfirm', 'draftInfo'].includes(leftTab) ? (<Drafts />)
                    : ['layers', 'layerInfo', 'layerDeleteConfirm', 'layerSaveConfirm'].includes(leftTab) ? (<Layers />)
                    : (<StartMenu />)
                 }
            </Box>
            <Box className="volume-wrapper">
                <Player />
            </Box>
        </Box >
    )
}

export default LeftSidebar